import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PetRakunoriEffect } from './pet-rakunori.effect';
import { petRakunoriReducer } from './pet-rakunori.reducer';
import { PET_RAKUNORI_STORE_NAME, PetRakunoriState } from './pet-rakunori.state';

/** Token of the PetRakunori reducer */
export const PET_RAKUNORI_REDUCER_TOKEN = new InjectionToken<ActionReducer<PetRakunoriState, Action>>(
  'Feature PetRakunori Reducer'
);

/** Provide default reducer for PetRakunori store */
export function getDefaultPetRakunoriReducer() {
  return petRakunoriReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(PET_RAKUNORI_STORE_NAME, PET_RAKUNORI_REDUCER_TOKEN),
    EffectsModule.forFeature([PetRakunoriEffect]),
  ],
  providers: [{ provide: PET_RAKUNORI_REDUCER_TOKEN, useFactory: getDefaultPetRakunoriReducer }],
})
export class PetRakunoriStoreModule {
  public static forRoot<T extends PetRakunoriState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<PetRakunoriStoreModule> {
    return {
      ngModule: PetRakunoriStoreModule,
      providers: [{ provide: PET_RAKUNORI_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
